import r2wc from '@r2wc/react-to-web-component';
import QuickCalculator from './Components/QuickCalculator';
import App from './App';
import Nordsjo from './Nordsjo';
import './styles/globals.scss';
import Kesko from './Kesko';

const HemfixareCalculator = r2wc(App, {
  props: {
    customer: 'string',
    modal: 'string',
    title: 'string',
    subtitle: 'string',
  },
  shadow: process.env.NODE_ENV === 'development' ? undefined : 'open',
});
const QuickCalculatorComponent = r2wc(QuickCalculator, {
  props: {
    customer: 'string',
  },
  shadow: process.env.NODE_ENV === 'development' ? undefined : 'open',
});
const NordsjoCalculator = r2wc(Nordsjo, {
  shadow: process.env.NODE_ENV === 'development' ? undefined : 'open',
});
const KeskoCalculator = r2wc(Kesko, {
  shadow: process.env.NODE_ENV === 'development' ? undefined : 'open',
});

customElements.define('hemfixare-calculator', HemfixareCalculator);
customElements.define('quick-calculator', QuickCalculatorComponent);
customElements.define('nordsjo-calculator', NordsjoCalculator);
customElements.define('kesko-calculator', KeskoCalculator);
